<template>
  <section>
    <div class="content_bg">
      
      <div class="content">
        <br/>
        <Caption :label="label"></Caption>
        <div class="text1">
          {{ desc }}
        </div>
        <ul>
          <li v-for="m of list">
            <SectionPriceSelectItem
              @select="onSelect"
              :record="m"
            />
          </li>
        </ul>
        <br/>
        <br/>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
import SectionPriceSelectItem from "./SectionPriceSelectItem.vue";
export default {
  props: ["label", "list", "desc"],
  components: {
    Caption,
    SectionPriceSelectItem,
  },
  data() {
    return {
    };
  },
  methods: {
    onSelect(record) {
      this.$emit("select", record);
    },
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: fit-content;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  height: 100%;
  max-width: 1258px;
  padding: 0 20px 0px 20px;
  z-index: 1;
  /* background-color: #f00; */
}

ul {
  margin-top: 20px;
  width: 100%;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding:0;
}
li:not(:last-child) {
  margin-right: 15px;
  margin-bottom: 15px;
}

ul li {
  display: inline-block;
}

.text1 {
  margin-top:30px;
  color:#333333;
  font-size: 22px;
  font-weight: 200;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: block;
    justify-content: center;
    width: 100vw;
    height: fit-content;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
  }

  .circle {
    position: absolute;
    top: 550px;
    left: -30px;
    z-index: 0;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 80px 20px 120px 20px;
    z-index: 100;
    /* background-color: #f00; */
  }

  .welcome_box {
    margin-top: 40px;
    width: 248px;
    z-index: 99;
  }

  .welcome_text1 {
    font-weight: 700;
    font-size: 32px;
    color: #ffffff;
    letter-spacing: -1px;
    margin-bottom: 0.5em;
  }
}
</style>
  